module.exports = __webpack_public_path__ + "static/media/success-square.0e3967bf.svg";